import { alpha } from '@mui/material/styles';

import { TOUCH_TARGET_SIZE, belowSm } from './touchTarget';

// ----------------------------------------------------------------------

const COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];

export default function Pagination(theme) {
  const isLight = theme.palette.mode === 'light';

  const rootStyle = (ownerState) => {
    const outlinedVariant = ownerState.variant === 'outlined';

    const softVariant = ownerState.variant === 'soft';

    const defaultStyle = {
      '& .MuiPaginationItem-root': {
        ...(outlinedVariant && {
          borderColor: alpha(theme.palette.grey[500], 0.32),
        }),
        '&.Mui-selected': {
          fontWeight: theme.typography.fontWeightMedium,
        },
      },
    };

    const colorStyle = COLORS.map((color) => ({
      ...(ownerState.color === color && {
        ...(softVariant && {
          '& .MuiPaginationItem-root': {
            '&.Mui-selected': {
              color: theme.palette[color][isLight ? 'dark' : 'light'],
              backgroundColor: alpha(theme.palette[color].main, 0.16),
              '&:hover': {
                backgroundColor: alpha(theme.palette[color].main, 0.32),
              },
            },
          },
        }),
      }),
    }));

    return [...colorStyle, defaultStyle];
  };

  return {
    MuiPagination: {
      defaultProps: {
        color: 'primary',
        siblingCount: 1,
        boundaryCount: 1,
      },

      styleOverrides: {
        root: ({ ownerState }) => ({
          ...rootStyle(ownerState),
          '& .MuiPaginationItem-previousNext': {
            minWidth: '32px',
            padding: '0 6px',
          },
          // Sem a margem de 3 px do MUI, 7 itens de 44 px cabem em 308 px; com ela seriam 350. As
          // reticências não são alvo de toque e ficam com a largura de desktop.
          ...belowSm(theme, {
            '& .MuiPaginationItem-root': {
              margin: 0,
            },
            '& .MuiPaginationItem-page, & .MuiPaginationItem-previousNext, & .MuiPaginationItem-firstLast':
              {
                minWidth: TOUCH_TARGET_SIZE,
                height: TOUCH_TARGET_SIZE,
              },
            '& .MuiPaginationItem-page:not(.MuiPaginationItem-rounded)': {
              borderRadius: TOUCH_TARGET_SIZE / 2,
            },
          }),
        }),
        ul: {
          gap: '0px',
          '& > li': {
            margin: '0',
          },
        },
      },
    },
  };
}
